import React from 'react';
import * as classnames from 'classnames/bind';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';

const styles = require('./ActiveUserTooltip.less');
const cx = classnames.bind(styles);

interface ActiveUserTooltipProps {
    fullName:string;
}

export class ActiveUserTooltip extends React.Component<ActiveUserTooltipProps>
{
    public render()
    {
        const {fullName} = this.props;

        return <Row className={cx('tooltipContainer')}>
            <Column className={cx('fullNameColumn')}>
                {fullName}
            </Column>
        </Row>
    }
}